import { UnknownField } from 'components/common-form/builder/form/node/field/UnknownField';
import { SummarySensitivityBlock } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/block/SummarySensitivityBlock';
import { CostsAndChargesField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/CostsAndChargesField';
import { ProductSummaryDatesListField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/DatesListField';
import { ProductSummaryIntWithUnitsField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/int-with-units-field';
import { ProductSummaryMultipleUnitsField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/multiple-units-field';
import { OptimizedBasketsField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/OptimizedBasketsField';
import { ProductSummaryPresetDate } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/preset-date-field';
import { ProductSummaryGreeksField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/ProductSummaryGreeksField';
import { ScheduleComponent } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/Schedule/Schedule';
import { ProductSummaryTextListField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/TextListField';
import { ProductSummaryUnderlyingField } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/fields/underlying-field';
import { ProductSummaryNodeProps } from 'components/common-form/sidePanel/docToolbar/summary/builder/ProductSummaryBuilder';

import { DefaultBlock } from './node/block/DefaultBlock';
import { ProductSummaryAdditionalCalendarsField } from './node/fields/AdditionalCalendarsField';
import { ProductSummaryAmountField } from './node/fields/AmountField';
import { ProductSummaryClientField } from './node/fields/ClientField';
import { ProductSummaryDate } from './node/fields/DateField';
import { ProductSummaryDealSplitField } from './node/fields/DealSplitField';
import { ProductSummaryFixedUnitField } from './node/fields/FixedUnitField';
import { ProductSummaryFixedUnitWithPostValueField } from './node/fields/FixedUnitWithPostValueField';
import { ProductSummaryFixedUnitWithPreValueField } from './node/fields/FixedUnitWithPreValueField';
import { ProductSummaryNumberField } from './node/fields/NumberField';
import { ProductSummaryDistributionCountryField } from './node/fields/ProductSummaryDistributionCountryField';
import { ProductSummaryLinksListField } from './node/fields/ProductSummaryLinksListField';
import { ProductSummaryScheduleDatesField } from './node/fields/ScheduleDates/ScheduleDates';
import { ProductSummaryTenorField } from './node/fields/TenorField';
import { ProductSummaryTextField } from './node/fields/TextField';
import { ProductSummaryTextWithDoublePostValuesField } from './node/fields/TextWithDoublePostValuesField';
import { ProductSummaryTextWithPostValueField } from './node/fields/TextWithPostValueField';
import { ProductSummaryToggleField } from './node/fields/ToggleField';
import { ProductSummaryUnderlyingsField } from './node/fields/UnderlyingsField';

export function componentForTypeAndId({ node, ...props }: ProductSummaryNodeProps) {
  switch (node.type) {
    case 'SensitivityBlock':
      return <SummarySensitivityBlock node={node} {...props} />;
    case 'Amount':
      return <ProductSummaryAmountField node={node} {...props} />;
    case 'Client':
      return <ProductSummaryClientField node={node} {...props} />;
    case 'Date':
      return <ProductSummaryDate node={node} {...props} />;
    case 'DatesList':
      return <ProductSummaryDatesListField node={node} {...props} />;
    case 'PresetDate':
      return <ProductSummaryPresetDate node={node} {...props} />;
    case 'DealSplitGrid':
      return <ProductSummaryDealSplitField node={node} {...props} />;
    case 'Default':
      return <DefaultBlock node={node} {...props} />;
    case 'FixedUnit':
      return <ProductSummaryFixedUnitField node={node} {...props} />;
    case 'FixedUnitWithPostValue':
      return <ProductSummaryFixedUnitWithPostValueField node={node} {...props} />;
    case 'Toggle':
      return <ProductSummaryToggleField node={node} {...props} />;
    case 'FixedUnitWithPreValue':
      return <ProductSummaryFixedUnitWithPreValueField node={node} {...props} />;
    case 'Number':
      return <ProductSummaryNumberField node={node} {...props} />;
    case 'ScheduleDatesGrid':
      return <ProductSummaryScheduleDatesField node={node} {...props} />;
    case 'SwapScheduleGrid':
      return <ScheduleComponent node={node} {...props} />;
    case 'ExerciseScheduleGrid':
      return <ScheduleComponent node={node} {...props} />;
    case 'Tenor':
      return <ProductSummaryTenorField node={node} {...props} />;
    case 'Text':
      return <ProductSummaryTextField node={node} {...props} />;
    case 'TextList':
      return <ProductSummaryTextListField node={node} {...props} />;
    case 'TextWithPostValue':
      return <ProductSummaryTextWithPostValueField node={node} {...props} />;
    case 'TextWithDoublePostValues':
      return <ProductSummaryTextWithDoublePostValuesField node={node} {...props} />;
    case 'Underlyings':
      return <ProductSummaryUnderlyingsField node={node} {...props} />;
    case 'Underlying':
      return <ProductSummaryUnderlyingField node={node} {...props} />;
    case 'DistributionCountryGrid':
      return <ProductSummaryDistributionCountryField node={node} {...props} />;
    case 'LinksList':
      return <ProductSummaryLinksListField node={node} {...props} />;
    case 'OptimizedBasketsResultsGrid':
      return <OptimizedBasketsField node={node} {...props} />;
    case 'CostsAndChargesResultsGrid':
      return <CostsAndChargesField workspaceType={'static'} node={node} {...props} />;
    case 'AdditionalCalendars':
      return <ProductSummaryAdditionalCalendarsField node={node} {...props} />;
    case 'Greeks':
      return <ProductSummaryGreeksField />;
    case 'MultipleUnits':
      return <ProductSummaryMultipleUnitsField node={node} {...props} />;
    case 'IntWithUnits':
      return <ProductSummaryIntWithUnitsField node={node} {...props} />;
    default:
      return <UnknownField workspaceType={'static'} node={node} {...props} />;
  }
}
